// swalHelper.js
import Swal from 'sweetalert2'

export const showError = (message, title = 'Oops...') => {
  Swal.fire({
    icon: 'error',
    title,
    text: message,
    timer: 3000,
    toast: true,
    position: 'top-end',
    timerProgressBar: true,
    showConfirmButton: false,
  })
}

export const showSuccess = (message = 'Success', title = 'Success') => {
  Swal.fire({
    icon: 'success',
    title,
    text: message,
    timer: 3000,
    toast: true,
    position: 'top-end',
    timerProgressBar: true,
    showConfirmButton: false,
  })
}
